import { schema } from 'normalizr';

/* ---------------- Lab -------------------------------- */
export const reportSchema = new schema.Entity('reports', {}, { idAttribute: 'labReportId' });

/* ---------------- Webchat ---------------------------- */
export const channelSchema = new schema.Entity('channels', {}, {
  idAttribute: 'channelId',
});

const patient = new schema.Entity('patient');

export const invitationSchema = new schema.Entity('invitation');
export const privateConsultSchema = new schema.Entity('privateConsult');

export const consultSchema = new schema.Entity('consult', {
  invitations: [invitationSchema],
  privateConsult: privateConsultSchema,
});

export const conversation = new schema.Entity('conversation', {
  latestConsult: consultSchema,
});

export const conversations = new schema.Array(conversation);


export const messageSchema = new schema.Entity('messages');

export const messagesSchema = new schema.Array(messageSchema);

export const healthSummarySchema = new schema.Entity('healthSummaries');

/* ---------------- Account Management ----------------- */
export const organisationSchema = new schema.Entity('organisations', {}, { idAttribute: 'id' });
export const applicationSchema = new schema.Entity('applications', {}, { idAttribute: 'id' });

/* --------------- Appointment ------------- */
export const summarySchema = new schema.Entity('summaries');
export const appointmentSchema = new schema.Entity('appointments', {
  summary: summarySchema,
});
export const timeslotSchema = new schema.Entity('timeslots', {
  appointments: [appointmentSchema],
});
